const ns = {};

/**
 * Ein jQuery-basierter Helper, um Elemente eines Formulars anzusprechen.
 * Vorteil: Wird die Formular-ID angepasst, muessen nicht alle Element-IDs im JS
 * angepasst werden, sofern mit diesem Helper gearbeitet wurde.
 *
 * @param {String} formId
 */
ns.Form = function(formId) {
    this.form = null;
    this.formId = formId;
};

/**
 * Gibt das Form zurueck. Hierbei wird ueberprueft, ob das Form (noch) existiert
 * und nur falls dem nicht so ist wird ein neues Objekt zurueckgegeben.
 *
 * @returns {jQuery}
 */
ns.Form.prototype.getForm = function () {

    var isFormInDom = this.form !== null && $.contains(document.documentElement,
            this.form[0]);

    if (!isFormInDom) {
        this.form = $('#' + this.formId);
    }

    return this.form;
};

/**
 * Gibt das Element mit der angegebenen kurz-ID zurueck.
 *
 * @param {String} shortElementId NICHT die HTML-ID, sondern die aus dem Backend
 * @returns {jQuery}
 */
ns.Form.prototype.get = function(shortElementId) {
    shortElementId = shortElementId.replace(/\[/g, '\\[').replace(/\]/g, '\\]');
    return this.getForm().find('#' + this.formId + this.ucfirst(shortElementId));
};

/**
 * Eine Facade fuer $(document).on(evtName, elementId, handler), wobei elementId
 * automatisch berechnet wird. Desweiteren wird der Kontext des Event-Handlers
 * so veraendert, dass $(this) auf das gewuenschte Element und nicht auf document
 * weist.
 *
 * @param {String} evtName
 * @param {String} shortElementId
 * @param {Function} handler
 * @returns {Form}
 */
ns.Form.prototype.on = function (evtName, shortElementId, handler) {

    if (typeof evtName !== 'string' || typeof shortElementId !== 'string' ||
            typeof handler !== 'function') {
        throw new Error('Please pass correct arguments to Form.on');
    }

    $(document).on(evtName, '#' + this.formId + this.ucfirst(shortElementId),
            function (e) {
        handler.apply(e.target, arguments);
    });

    return this;
};

/**
 * Konvertiert den ersten Buchstaben des uebergebenen Strings zu lowerCase und
 * gibt den String zurueck.
 *
 * Entiwckler-Hinweis: Bei Gelegenheit auslagern.
 *
 * @param {String} str
 * @returns {String}
 */
ns.Form.prototype.ucfirst = function(str) {
    return str.charAt(0).toUpperCase() + str.slice(1);
};

/**
 * Resettet die Elemente mit den angegebenen kurz-IDs (es koennen beliebig viele
 * Argumente uebergeben werden).
 * Dazu wird das Element analysiert und je nach Element folgendes gemacht:
 *   Select:                               Auswählen der ersten Option
 *   Textartige Inputs, Textarea/CKEditor: Setzen auf leeren String
 *   Radios/Checkboxen:                    Alle unchecken
 *
 * Ggf. sind Spazial-Anpassungen notwendig (z. B. bei Radios), da muss dann
 * mittels Form::get() gearbeitet werden.
 *
 * @param {...String} shortElementId1 NICHT die HTML-ID, sondern die aus dem Backend
 * @returns {Form}
 */
ns.Form.prototype.reset = function(shortElementId1) {
    for (var i = 0; i < arguments.length; i++) {
        var shortElementId = arguments[i];
        var el = this.get(shortElementId);
        var tagName = el.prop('tagName').toLowerCase();

        if (tagName === 'input' && (el.attr('type') !== 'radio' &&
                el.attr('type') !== 'checkbox')) {
            el.val('');
        } else if (tagName === 'input') {
            el.prop('checked', false);
        } else if (tagName === 'select') {
            el.val(el.find('option:first').val());
            el.trigger('chosen:updated');
        } else if (tagName === 'textarea') {

            el.html('');

            var ckProp = this.formId + this.ucfirst(shortElementId);

            if (typeof CKEDITOR !== 'undefined' &&
                    CKEDITOR.instances.hasOwnProperty(ckProp)) {
                CKEDITOR.instances[ckProp].setData('');
            } else {
                el.val('');
            }
        }
    }

    return this;
};

export default ns.Form;
